module.exports = __webpack_public_path__ + "bf2532df/img/share-icon.f5a05c4d.svg";